import { FetchRequestError } from "../FetchRequestError";
import type { UserEncodedErrorShape } from "./types";

export const isUserEncodedError = (json: Record<string, unknown> | undefined): json is UserEncodedErrorShape => {
  return (
    typeof json?.message === "string" &&
    typeof json?.error_code === "string" &&
    (json?.meta ? typeof json.meta === "object" : true)
  );
};

/**
 * describes an error for which we have a unique error code and meta properties
 * about the error.
 */
export class FetchUserEncodedError<Code extends string, Meta = Record<string, unknown>> extends FetchRequestError {
  errorCode: Code;
  meta: Meta;
  fallbackMessage: string;

  constructor(statusCode: number, statusText: string, responseJson: UserEncodedErrorShape) {
    super(statusCode, statusText, responseJson);

    this.errorCode = responseJson.error_code as unknown as Code;
    this.meta = responseJson.meta as unknown as Meta;
    this.fallbackMessage = responseJson.message;
  }

  override isUnexpectedSystemError(): boolean {
    return false;
  }
}
